import React from 'react';
import { createRoot } from 'react-dom/client';
import * as serviceWorker from './serviceWorker';
import App from './App';

const rootElement = document.getElementById('root');
createRoot(rootElement).render(<App />);

serviceWorker.unregister();
